import {
  checkScrolledToBottom,
  isContentScrollable,
  isNewLetConfirmEnabled,
} from "@/common/eligibility";

/**
 * Mixin providing shared eligibility scroll-gate and new-let state logic.
 * Requires the component to have a `ref="eligibilityContent"` on the scrollable element.
 */
export default {
  data() {
    return {
      hasScrolledToBottom: false,
      newLetState: {
        answered: false,
        value: null,
        checkboxTicked: false,
      },
    };
  },
  computed: {
    isConfirmEnabled() {
      return isNewLetConfirmEnabled(this.newLetState);
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!isContentScrollable(this.$refs.eligibilityContent)) {
        this.hasScrolledToBottom = true;
      }
    });
  },
  methods: {
    onNewLetStateChanged(state) {
      this.newLetState = state;
    },
    onContentScroll() {
      this.hasScrolledToBottom = checkScrolledToBottom(
        this.$refs.eligibilityContent,
        this.hasScrolledToBottom
      );
    },
  },
};
